import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./ApplicationStepper.module.scss";
import useDomainStore from "../../../../../../stores/domain";
import CaretDown from "../../../../../../assets/svg/icons/common/CaretDown";

/**
 * ApplicationStepper component
 * Displays the application progress steps in the thank you page
 */
const ApplicationStepper = ({ currentStep = 1 }) => {
  const { isKurvDomain } = useDomainStore();
  const [stepperOpen, setStepperOpen] = useState(false);

  const handleStepperCaretClick = () => {
    setStepperOpen((prev) => !prev);
  };

  const steps = [
    { id: 1, label: "Application sent" },
    { id: 2, label: "Verification" },
    { id: 3, label: "Approved" },
    { id: 4, label: "Deployment" },
    { id: 5, label: "Done" },
  ];

  const renderSteps = steps.map((step, index) => (
    <div key={step.id} className={styles.stepItem}>
      <div className={styles.stepVisual}>
        <div
          className={`${styles.stepCircle} ${step.id <= currentStep ? styles.active : ""}`}
        />
        {index < steps.length - 1 && (
          <div
            className={`${styles.stepLine} ${step.id <= currentStep ? styles.active : ""}`}
          />
        )}
      </div>
      <span
        className={`${styles.stepLabel} ${step.id <= currentStep ? styles.activeLabel : ""}`}
      >
        {step.label}
      </span>
    </div>
  ));

  return (
    <>
      <div
        className={`${styles.mobileStepperContainer} ${isKurvDomain ? styles.kurv_theme : ""}`}
      >
        <div className={styles.currentStep} onClick={handleStepperCaretClick}>
          <div className={styles.currentStepLabelContainer}>
            <div className={`${styles.stepCircle} ${styles.active}`}></div>
            <span className={styles.currentStepLabel}>
              {steps[currentStep - 1]?.label}
            </span>
          </div>

          <div className={styles.currentStepNumber}>
            <span className={styles.currentStepNumberLabel}>
              {currentStep}/{steps.length}
            </span>

            <CaretDown
              className={`${styles.currentStepNumberIcon} ${stepperOpen ? styles.open : ""}`}
              width={16}
              height={16}
            />
          </div>
        </div>

        <div
          className={`${styles.mobileStepper} ${stepperOpen ? styles.open : ""}`}
        >
          {renderSteps}
        </div>
      </div>
      <div
        className={`${styles.stepperContainer} ${isKurvDomain ? styles.kurv_theme : ""}`}
      >
        {renderSteps}
      </div>
    </>
  );
};

ApplicationStepper.propTypes = {
  currentStep: PropTypes.number,
};

export default ApplicationStepper;
